import React, { useState, useEffect } from 'react';
import { useDashboardDomainContext } from "../../DashboardDomainProvider";
import { IconControl } from 'spark-core-dx/components';
import moment from 'moment';

const TabWrapper = ({ handleContextMenu, scrollRef }) => {
  const {
    dashboardUserNavStateLib,
    dashboardLib,
    isLoading,
  } = useDashboardDomainContext();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const el = scrollRef.current;
      if (el) setIsOverflowing(el.scrollWidth > el.clientWidth);
    };
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardUserNavStateLib?.dashboardTabs]);

  useEffect(() => {
    if (!hasScrolled && dashboardUserNavStateLib?.scrollPosition && scrollRef.current) {
      scrollRef.current.scrollLeft = dashboardUserNavStateLib.scrollPosition;
      setHasScrolled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardUserNavStateLib?.scrollPosition]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const atStart = el.scrollLeft === 0;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      setIsAtStart(atStart);
      setIsAtEnd(atEnd);
    };

    window.addEventListener('resize', handleScroll);
    el.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('resize', handleScroll);
      el.removeEventListener('scroll', handleScroll);
    };
  }, [scrollRef, isLoading]);

  const scrollByOneTab = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const tabs = Array.from(container.querySelectorAll(".tab"));
    const containerRect = container.getBoundingClientRect();

    if (direction === 'right') {
      const nextTab = tabs.find(tab => {
        const tabRect = tab.getBoundingClientRect();
        return tabRect.left > containerRect.left + 10;
      });
      if (nextTab) {
        const scrollPos = nextTab.offsetLeft - 85;
        container.scrollTo({ left: scrollPos, behavior: 'smooth' });
        dashboardUserNavStateLib.updateScrollPosition(Math.round(scrollPos));
      }
    } else {
      const previousTabs = tabs.filter(tab => {
        const tabRect = tab.getBoundingClientRect();
        return tabRect.left < containerRect.left - 10;
      });
      const prevTab = previousTabs[previousTabs.length - 1];
      if (prevTab) {
        const scrollPos = prevTab.offsetLeft - 85;
        const isFirstTab = tabs.indexOf(prevTab) === 0;
        const finalScrollPos = isFirstTab ? 0 : scrollPos;
        container.scrollTo({ left: finalScrollPos, behavior: 'smooth' });
        dashboardUserNavStateLib.updateScrollPosition(Math.round(finalScrollPos));
      }
    }
  };

  return (
    <div className="tab-wrapper">
      <div className="tab-container" ref={scrollRef}>
        {dashboardUserNavStateLib?.dashboardTabs?.map(tab => {
          const dashboardInfo = dashboardLib?.dashboardList?.find(x => x._id === tab);
          const published = dashboardInfo?.State?.IsPublished;
          const isTemplate = dashboardInfo?.State?.IsTemplate;

          const title = published
            ? (dashboardInfo?.PublishedDetails?.Name || (console.error("Published Name is missing."), "Untitled"))
            : (dashboardInfo?.DraftDetails?.Name
                ? dashboardInfo?.DraftDetails?.Name
                : `Draft-${moment(dashboardInfo?.UpdatedDate).format('MM/DD/YY')}`);

          const icon = published
            ? dashboardInfo?.PublishedDetails?.Icon
            : dashboardInfo?.DraftDetails?.Icon;

          return (
            <div
              className={`tab${dashboardUserNavStateLib?.selectedTab === dashboardInfo?._id ? ' selected' : ''}`}
              key={tab}
              onClick={() => dashboardUserNavStateLib?.selectDashboard(dashboardInfo?._id)}
              title={title}
            >
              <div className="tab-name">
                {icon && <IconControl iconKey={icon} />}
                <div className={`tab-text ${isTemplate ? ' template' : ''}`}>
                  {title}
                </div>
              </div>
              <IconControl
                onClick={(e) => { handleContextMenu(e, tab); e.stopPropagation(); }}
                iconKey={"arrowdropdown"}
              />
            </div>
          );
        })}
      </div>

      <div className="menu-buttons right">
        <IconControl
          className={`menu-button-icon left-arrow${!isOverflowing || isAtStart ? ' disabled' : ''}`}
          iconKey={"arrowdropdown"}
          onClick={() => scrollByOneTab('left')}
        />
        <IconControl
          className={`menu-button-icon right-arrow${!isOverflowing || isAtEnd ? ' disabled' : ''}`}
          iconKey={"arrowdropdown"}
          onClick={() => scrollByOneTab('right')}
        />
      </div>
    </div>
  );
};

export default TabWrapper;
